import { render } from "./LocalGithubActivity.vue?vue&type=template&id=048edf1e&scoped=true&ts=true"
import script from "./LocalGithubActivity.vue?vue&type=script&lang=ts"
export * from "./LocalGithubActivity.vue?vue&type=script&lang=ts"

import "./LocalGithubActivity.vue?vue&type=style&index=0&id=048edf1e&scoped=true&lang=css"
import "./LocalGithubActivity.vue?vue&type=style&index=1&id=048edf1e&lang=css"

import exportComponent from "/home/bwhite/Projects/bryanchriswhite-com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048edf1e"]])

export default __exports__